var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"text-center text-white"},[_vm._v("\n    © Copyright "+_vm._s((new Date()).getFullYear())+" Fivenomics. All Rights Reserved\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }